import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager } from 'ng-jhipster';
import { AutoComplete } from 'primeng/primeng';
import { isNullOrUndefined } from 'util';
import { CampaignService } from '../../entities/campaign/campaign.service';
import { Master } from '../../entities/master/master.model';
import { MasterService } from '../../entities/master/master.service';
import { JhiLanguageHelper, Principal, User, UserService } from '../../shared';
import { MultiSelectOption } from '../../shared/utils/utils.service';
import { Academy, Region } from './region.model';
import { RegionService } from './region.service';
import { UserModalService } from './user-modal.service';



@Component({
    selector: 'jhi-user-mgmt-dialog',
    templateUrl: './user-management-dialog.component.html'
})
export class UserMgmtDialogComponent implements OnInit {

    user: User;
    languages: any[];
    authorities: any[];
    isSaving: Boolean;
    selectedProfile: any;
    account: any;
    masterSchools: Master[];
    masters: Master[];
    possibleSchoolAssignedMasters: MultiSelectOption[];
    academicRegions: Region[];
    academies = [];
    campaign: string;
    results = [];

    @ViewChild('schoolAssignedMastersAutoComplete') schoolAssignedMastersAutoComplete: AutoComplete;


    private _schoolAssignedMasters: MultiSelectOption[] = [];
    set schoolAssignedMasters(masters: MultiSelectOption[]) {
        this._schoolAssignedMasters = masters;
        this.user.schoolAssignedMasters = masters.map(m => m.value);
    }
    get schoolAssignedMasters(): MultiSelectOption[] {
        return this._schoolAssignedMasters;
    }

    constructor(
        public activeModal: NgbActiveModal,
        private languageHelper: JhiLanguageHelper,
        private userService: UserService,
        private eventManager: EventManager,
        private principal: Principal,
        private masterService: MasterService,
        private regionService: RegionService,
        private campaignService: CampaignService
    ) { }

    filterMasters(arr: Master[]): Master[] {
        let f = new Array<String>();
        return arr.filter((n) => f.indexOf(n.masterSchoolUai) === -1 && f.push(n.masterSchoolUai));
    }

    filterMastersForRegion(arr: Master[], region: string): Master[] {
        let f = new Array<String>();
        return arr.filter((n) => n.academicRegionLabel === region && f.indexOf(n.masterSchoolUai) === -1 && f.push(n.masterSchoolUai));
    }

    filterMastersForSchool(arr: Master[], school: string): Master[] {
        let f = new Array<String>();
        return arr.filter((n) => n.masterSchoolUai === school && f.indexOf(n.masterSchoolUai) === -1 && f.push(n.masterSchoolUai));
    }

    updatePossibleSchoolAssignedMasters() {
        this.possibleSchoolAssignedMasters = this.masters
            .filter((n) => n.masterSchoolUai === this.user.schoolUai)
            .sort((a, b) => a.formationLabel.localeCompare(b.formationLabel))
            .map(m => { return { value: m.masterInm, label: m.formationLabel }; });
        this.schoolAssignedMasters = !this.user.schoolAssignedMasters ? [] : this.possibleSchoolAssignedMasters.filter(m => !!this.user.schoolAssignedMasters.find(um => um === m.value));
    }
    search(event) {
        this.results = this.possibleSchoolAssignedMasters.filter(m => m.label.toLowerCase().includes(event.query.toLowerCase())
                                                                && (!this.user.schoolAssignedMasters || !this.user.schoolAssignedMasters.find(um => um === m.value)));
    }

    setAcademiesFromAcademicRegions() {
        this.academicRegions.forEach(reg => {
            if (!isNullOrUndefined(reg.academies)) {
                reg.academies.forEach(aca => {
                    if (!isNullOrUndefined(aca)) {
                        this.academies.push(aca);
                    }
                });
            }
        });
        this.sortAcademiesByAlphabeticalOrder();
    }

    async ngOnInit() {
        // this.campaign = this.headerService
        this.isSaving = false;
        this.academicRegions = new Array<Region>();
        this.campaign = this.campaignService.getDisplayedCampaign();
        this.masters = await this.masterService.getMasters().toPromise();

        if (this.principal.hasSyncAuthority('ROLE_ADMIN')) {
            this.authorities = ['ROLE_ADMIN', 'ROLE_ADMINMINISTRY', 'ROLE_MINISTRY', 'ROLE_ACADEMICREGIONRECTOR', 'ROLE_ACADEMICRECTOR', 'ROLE_SCHOOL_ADMIN', 'ROLE_SCHOOL_MANAGER', 'ROLE_SCHOOL_CONSULT'];
            this.regionService.getRegions({ 'campaign': this.campaign }).subscribe(regions => {
                this.academicRegions = regions as Region[];
                this.setAcademiesFromAcademicRegions();
            });
            this.masterSchools = this.filterMasters(this.masters);
            this.sortMasterSchoolsByAlphabeticalOrder();
        } else if (this.principal.hasSyncAuthority('ROLE_MINISTRY')) {
            this.authorities = ['ROLE_MINISTRY'];
        } else if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
            this.authorities = ['ROLE_ACADEMICREGIONRECTOR', 'ROLE_ACADEMICRECTOR', 'ROLE_SCHOOL_ADMIN'];
            this.regionService.getRegions({ 'campaign': this.campaign }).subscribe(regions => {
                this.academicRegions = regions.filter(r => r.academicRegionLabel === this.principal.getAcademicRegionLabel());
                this.setAcademiesFromAcademicRegions();
            });
            this.masterSchools = this.filterMastersForRegion(this.masters, this.principal.getAcademicRegionLabel());
            this.sortMasterSchoolsByAlphabeticalOrder();
        } else if (this.principal.hasSyncAuthority('ROLE_ACADEMICRECTOR')) {
            this.authorities = ['ROLE_ACADEMICRECTOR'];
            this.academies.push(new Academy(this.principal.getAcademyLabel(), this.principal.getAcademyCode()));
            this.academicRegions.push(new Region(this.principal.getAcademicRegionLabel(), this.academies));
        } else if (this.principal.hasSyncAuthority('ROLE_SCHOOL_ADMIN')) {
            this.authorities = ['ROLE_SCHOOL_ADMIN', 'ROLE_SCHOOL_MANAGER', 'ROLE_SCHOOL_CONSULT'];
            this.masterSchools = this.filterMastersForSchool(this.masters, this.principal.getSchoolUai());
            this.sortMasterSchoolsByAlphabeticalOrder();
        }

        if (this.user.id === null) {
            this.user.academicRegionLabel = this.principal.getAcademicRegionLabel();
            this.user.academyCode = this.principal.getAcademyCode();
            this.user.schoolUai = this.principal.getSchoolUai();
            this.selectedProfile = this.authorities[0];
        } else {
            this.user.authorities.splice(this.user.authorities.indexOf('ROLE_INTERNAL'), 1);
            if (this.user.authorities.indexOf('ROLE_ADMIN') !== -1 && this.user.authorities.indexOf('ROLE_MINISTRY') !== -1) {
                this.selectedProfile = 'ROLE_ADMINMINISTRY';
            } else {
                this.selectedProfile = this.user.authorities[0];
            }
        }
        this.updatePossibleSchoolAssignedMasters();

        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
        });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.selectedProfile === 'ROLE_ADMINMINISTRY') {
            this.user.authorities = ['ROLE_ADMIN', 'ROLE_MINISTRY'];
        } else {
            this.user.authorities = [this.selectedProfile];
        }
        this.user.authorities.push('ROLE_INTERNAL');
        if (this.user.schoolAssignedMasters && this.user.schoolAssignedMasters.length === 0) {
            this.user.schoolAssignedMasters = null;
        }

        if (this.user.id !== null) {
            this.userService.update(this.user).subscribe(response => this.onSaveSuccess(response), () => this.onSaveError());
        } else {
            this.userService.create(this.user).subscribe(response => this.onSaveSuccess(response), () => this.onSaveError());
        }
    }

    private onSaveSuccess(result) {
        this.eventManager.broadcast({ name: 'userListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError() {
        this.isSaving = false;
    }

    sortMasterSchoolsByAlphabeticalOrder() {
        return this.masterSchools = this.masterSchools.sort((m1, m2) => m1.masterSchoolName.localeCompare(m2.masterSchoolName));
    }

    sortAcademiesByAlphabeticalOrder() {
        return this.academies = this.academies.sort((m1, m2) => m1.academyLabel.localeCompare(m2.academyLabel));
    }


    openSchoolAssignedMastersDropdown(event) {
        if (!this.schoolAssignedMastersAutoComplete.panelVisible) {
            setTimeout(() => {
                this.schoolAssignedMastersAutoComplete.suggestions = [];
                setTimeout(() => this.schoolAssignedMastersAutoComplete.search(event, ''), 200);
            }, 200);
        }
    }

}

@Component({
    selector: 'jhi-user-dialog',
    template: ''
})
export class UserDialogComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private userModalService: UserModalService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['email']) {
                this.modalRef = this.userModalService.open(UserMgmtDialogComponent, params['email']);
            } else {
                this.modalRef = this.userModalService.open(UserMgmtDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/user-management-dialog.component.ts